import { Component, ViewEncapsulation,  ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DragulaService } from 'ng2-dragula';
import { ApiService } from 'app/shared/services/api.service';
import { Toast, ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-taskboard',
  templateUrl: './taskboard.component.html',
  styleUrls: ['./taskboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskboardComponent implements OnInit {
  
  taskData_normal:any
  taskData_medium:any
  taskData_high:any
  taskData_urgent:any
  userId:any
  user_role:any
  user_data:any
  public editing = {};
  selected_task_status=''
  currentUrl:any
  constructor(private dragulaService: DragulaService, private elRef: ElementRef,
     private modalService: NgbModal, public toastr: ToastrService,
     private ref: ChangeDetectorRef , private apiService : ApiService,
     private activatedRoute:ActivatedRoute) {
      this.currentUrl=this.activatedRoute.snapshot.routeConfig.path
      if(this.currentUrl ==='student-task/:id'){
        this.activatedRoute.paramMap.subscribe(params => { 
          this.userId = params.get('id'); 
      }); 
      }
      if(this.currentUrl !=='student-task/:id'){
        let localData=JSON.parse(localStorage.getItem('user'))
        this.user_role = localData.roles
        this.userId=localData.id
      }
        
      
  }
  ngOnInit() {
    if(this.currentUrl !=='student-task/:id'){
      if(this.user_role === 'employee'){
        this.getCurrentEmp(this.userId)
      }
      this.getTaskByUser(this.userId)
    }
    if(this.currentUrl ==='student-task/:id'){
      this.getTaskByUser(this.userId)
    }
   
    // this.dragulaService.drop('ITEMS')
    // .subscribe(({ el, target }) => {
    //   const elements = target.querySelectorAll('[task-id]');
    //   elements.forEach((element) => {
    //     const taskId = element.getAttribute('task-id');
    //     const priorityId = element.getAttribute('task-priority');
    //     this.updateTaskStatus(taskId,priorityId);
    //   });
    // });
    
  }
  getTaskByUser(id){
    this.apiService.getTaskByUserId(id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.taskData_normal = res.data

      }
    })
  }
  updateTaskStatus(id: string, status: string, task?: Task) {
    let badgeClass = 'primary';

    if (status === 'Marketing') {
      badgeClass = 'primary'
    }
    else if (status === 'UI-Designing') {
      badgeClass = 'warning'
    }
    else if (status === 'Developing') {
      badgeClass = 'success'
    }
    else if (status === 'Management') {
      badgeClass = 'info'
    }

    let currentTask: Task;

    if (task) {
      currentTask = task;
    }
    else {
      // currentTask = this.tasks.find(x => x.taskId === +id);
    }

    // let index = this.tasks.indexOf(currentTask);
    // currentTask.status = status;
    // currentTask.badgeClass = badgeClass;
    // this.tasks.splice(index, 1, currentTask);
    // this.tasks = [...this.tasks];
    // this.loadTasks();
  }
  getCurrentEmp(id){
    this.apiService.getEmployeeById(id).subscribe((res:any)=>{
      
      this.user_data = res?.data
      this.selected_task_status = this.user_data?.task_status
    })
  }
  empTaskStatusUpdated(data,id){
    this.selected_task_status = data
    let body ={
      task_status : data
    }
    this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Update successful')
        this.getCurrentEmp(this.userId)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
   /**
   * inlineEditingUpdate
   *
   * @param event
   * @param cell
 
   */
   inlineEditingUpdate(event, id) {
    let body={
      current_task:  event.target.value
    }
    this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.editing = {}
        this.toastr.success('Update successful')
        this.getCurrentEmp(this.userId)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
}
